import Route from '@ember/routing/route';

export default class TermsPolicy extends Route {
  // normal class body definition here
}
